import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Stack, Typography } from '@mui/material';
import { DescriptionRounded, ReceiptLongRounded } from '@mui/icons-material';

export default function DocumentModal({ open, onClose, onChoose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 950 }}>Documento tributario</DialogTitle>
      <DialogContent>
        <Grid container spacing={1.2} sx={{ pt: 0.5 }}>
          <Grid item xs={6}>
            <Paper onClick={() => onChoose?.('boleta')} elevation={0} sx={{ p: 2, border: '1px solid #cfe0f2', cursor: 'pointer', textAlign: 'center', '&:hover': { bgcolor: '#f4f9ff' } }}>
              <ReceiptLongRounded sx={{ fontSize: 40, color: '#1772e8' }} />
              <Typography fontWeight={950}>Boleta</Typography>
              <Typography variant="caption" color="text.secondary">DTE 39</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper onClick={() => onChoose?.('factura')} elevation={0} sx={{ p: 2, border: '1px solid #cfe0f2', cursor: 'pointer', textAlign: 'center', '&:hover': { bgcolor: '#f4f9ff' } }}>
              <DescriptionRounded sx={{ fontSize: 40, color: '#1772e8' }} />
              <Typography fontWeight={950}>Factura</Typography>
              <Typography variant="caption" color="text.secondary">DTE 33 · requiere cliente</Typography>
            </Paper>
          </Grid>
        </Grid>
        <Stack sx={{ mt: 1.4 }}>
          <Typography variant="caption" color="text.secondary">B = Boleta · F = Factura</Typography>
        </Stack>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Cancelar</Button></DialogActions>
    </Dialog>
  );
}
